module.exports = __webpack_public_path__ + "assets/img/19.1315328d.png";